(function(){
  var grid=document.querySelector('[data-rs-grid]');
  if(!grid) return;
  var cards=[].slice.call(grid.querySelectorAll('.mb-rs__c'));

  // Si la seccion trae configuracion (total, media y reparto) mandan esos
  // numeros. Si no, se calculan contando las tarjetas que hay de verdad.
  var cfg=null;
  var cont=document.querySelector('[data-rs-cfg]');
  if(cont){ try{ cfg=JSON.parse(cont.getAttribute('data-rs-cfg')); }catch(e){ cfg=null; } }

  var total, media, dist;
  if(cfg && cfg.total){
    total=cfg.total; media=cfg.media; dist=cfg.d || [0,0,0,0,0,0];
  }else{
    dist=[0,0,0,0,0,0];
    cards.forEach(function(c){
      var s=c.querySelector('.mb-rs__s');
      if(!s) return;
      var n=(s.textContent.match(/★/g)||[]).length;
      if(n>=1 && n<=5) dist[n]++;
    });
    var n2=dist.reduce(function(a,b){ return a+b; },0);
    if(!n2) return;
    var suma=0; for(var i=1;i<=5;i++) suma+=i*dist[i];
    total=String(n2);
    media=(Math.round(suma/n2*10)/10).toFixed(1);
  }

  var elMedia=document.querySelector('[data-rs-media]');
  if(elMedia) elMedia.textContent=media;
  document.querySelectorAll('[data-rs-total]').forEach(function(e){ e.textContent=total; });
  document.querySelectorAll('[data-rs-media-txt]').forEach(function(e){ e.textContent=media; });

  var suman=0; for(var k=1;k<=5;k++) suman+=(dist[k]||0);
  for(var n=1;n<=5;n++){
    var fila=document.querySelector('[data-rs-bar="'+n+'"]');
    if(!fila) continue;
    var pct=suman? Math.round((dist[n]||0)*100/suman) : 0;
    var b=fila.querySelector('u b'); if(b) b.style.width=pct+'%';
    var em=fila.querySelector('em');
    if(em) em.textContent=(dist[n]||0).toLocaleString('es-MX');
  }

  // El boton NO dice cuantas quedan a proposito: delataria cuantas
  // tarjetas hay listadas de verdad.
  var btn=document.querySelector('[data-rs-ver]');
  if(!btn) return;
  var vistas=0;
  function mostrar(n){
    var hasta=Math.min(cards.length, vistas+n);
    for(var i=vistas;i<hasta;i++) cards[i].setAttribute('data-ver','1');
    vistas=hasta;
    if(vistas>=cards.length) btn.hidden=true;
  }
  mostrar(4);
  btn.addEventListener('click', function(){ mostrar(vistas < 12 ? 4 : 12); });
})();
